import { withField } from '@libs/reduxForm';

import SelectBase from './SelectBase';

const Select = withField()((props) => <SelectBase {...props} />);

export { Select as default, SelectBase };
